export default "__VITE_ASSET__fILS8NDs2l_5K0kkSr$WXQ__"